var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19869 0H14.9014L23.9669 9.45791V27.8326C23.9669 30.1328 22.0997 32 19.7995 32H4.19869C1.89848 32 0.03125 30.1328 0.03125 27.8326V4.16744C0.03125 1.86723 1.89848 0 4.19869 0Z",
    fill: "#0AC963"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8867 0V9.37673H23.9658L14.8867 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0657 15.9932H7.93375C7.32489 15.9932 6.82422 16.4938 6.82422 17.1027V22.2714C6.82422 22.8803 7.32485 23.3809 7.93375 23.3809H16.0657C16.6745 23.3809 17.1616 22.8803 17.1616 22.2714V17.1027C17.1616 16.4938 16.6746 15.9932 16.0657 15.9932ZM10.1528 17.3868C10.8158 17.3868 11.3435 17.928 11.3435 18.5775C11.3435 19.2405 10.8158 19.7817 10.1528 19.7817C9.48977 19.7817 8.94855 19.2405 8.94855 18.5775C8.94855 17.928 9.48977 17.3868 10.1528 17.3868ZM16.431 22.2714C16.431 22.4744 16.2686 22.6502 16.0657 22.6502H7.93375C7.73078 22.6502 7.56841 22.4744 7.56841 22.2714V22.0549L9.04324 20.5801L10.261 21.7979C10.4098 21.9467 10.6399 21.9467 10.7887 21.7979L13.8466 18.7399L16.431 21.3243V22.2714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.b4b647b2956d81b338e05e9fc56b3998.svg";
export { ForwardRef as ReactComponent };